import React, { useEffect, useState } from 'react';

export default function ParentPinModal({ open, title, description, storedPin, onClose, onSuccess }) {
    const [value, setValue] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!open) {
            setValue('');
            setError('');
        }
    }, [open]);

    if (!open) {
        return null;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (value === storedPin) {
            setError('');
            onSuccess?.();
            return;
        }
        setError('Incorrect PIN.');
    };

    return (
        <div role="dialog" aria-modal="true" aria-labelledby="pin-modal-title" aria-describedby="pin-modal-desc" style={{ position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: '16px' }}>
            <div style={{ background: 'white', borderRadius: '20px', width: 'min(420px, calc(100vw - 32px))', padding: '24px', boxShadow: '0 24px 60px rgba(15, 23, 42, 0.28)' }}>
                <h3 id="pin-modal-title" style={{ marginTop: 0, marginBottom: '8px', color: '#0f172a' }}>{title}</h3>
                <p id="pin-modal-desc" style={{ marginTop: 0, color: '#475569', lineHeight: 1.6 }}>{description}</p>
                <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '14px' }}>
                    <input
                        type="password"
                        inputMode="numeric"
                        maxLength={4}
                        value={value}
                        onChange={(event) => setValue(event.target.value.replace(/\D/g, ''))}
                        placeholder="Enter 4-digit PIN"
                        aria-label="4-digit parent PIN"
                        aria-describedby={error ? 'pin-error' : undefined}
                        autoFocus
                        style={{ width: '100%', padding: '14px 16px', borderRadius: '14px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
                    />
                    {error && <div id="pin-error" role="alert" aria-live="assertive" style={{ color: '#dc2626', fontWeight: 600 }}>{error}</div>}
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                        <button type="button" onClick={onClose} aria-label="Cancel PIN entry" style={{ background: '#e2e8f0', color: '#0f172a', border: 'none', borderRadius: '12px', padding: '12px 16px', cursor: 'pointer', fontWeight: 700 }}>
                            Cancel
                        </button>
                        <button type="submit" aria-label="Unlock with PIN" style={{ background: '#4f46e5', color: 'white', border: 'none', borderRadius: '12px', padding: '12px 16px', cursor: 'pointer', fontWeight: 700 }}>
                            Unlock
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
